import * as React from 'react';


const CREFooter = (props) => (
    <div className="footer container mt-3 mb-3">
        <div className="row">
            <div className="col text-right">
                <ul className="footer-links footer-notlogo">
                    <li className="text-middle"><a href="/ContactUs" ><span className="text-nowrap">Contact Us</span></a></li>
                </ul>
            </div>
        </div>
    </div>
);

export default () => <CREFooter />;



// WEBPACK FOOTER //
// ./src/pages/CREFooter.tsx